import { render, staticRenderFns } from "./noticeListTabs.vue?vue&type=template&id=07339735&scoped=true&"
import script from "./noticeListTabs.vue?vue&type=script&lang=js&"
export * from "./noticeListTabs.vue?vue&type=script&lang=js&"
import style0 from "./noticeListTabs.vue?vue&type=style&index=0&id=07339735&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07339735",
  null
  
)

export default component.exports